import React from 'react';

const FIELDS = [
  { id: 'client_name', label: 'Client Full Name *', type: 'text', placeholder: 'John Doe', required: true },
  { id: 'client_email', label: 'Client Email Address *', type: 'email', placeholder: 'client@example.com', required: true },
];

const GUIDELINES = [
  'Introduce only clients you can vouch for',
  'Introductions are private',
  'You will not be notified of outcomes',
  'Not all requests are accepted',
];

const AdvisorClientForm = ({
  formData, handleChange, handleSubmit, sending, error, success, advisorInfo,
  getSubmitButtonText, availableTypes = [],
}) => (
  <div className="bg-gray-800 rounded-xl p-8 border border-gray-700">
    <h2 className="text-2xl font-bold text-white mb-6">Privately Introduce a Client</h2>
    {success && <div className="mb-6 p-4 bg-green-500/10 border border-green-500 rounded-lg text-green-400">{success}</div>}
    {error && <div className="mb-6 p-4 bg-red-500/10 border border-red-500 rounded-lg text-red-400">{error}</div>}
    <form onSubmit={handleSubmit} className="space-y-6">
      {FIELDS.map(f => (
        <div key={f.id}>
          <label htmlFor={f.id} className="block text-sm font-medium text-gray-300 mb-2">{f.label}</label>
          <input type={f.type} id={f.id} name={f.id} value={formData[f.id]} onChange={handleChange} required={f.required}
            className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-hidden focus:ring-2 focus:ring-green-500"
            placeholder={f.placeholder} />
        </div>
      ))}
      <div>
        <label htmlFor="professional_type" className="block text-sm font-medium text-gray-300 mb-2">
          Your relationship with this introducee *
        </label>
        <select
          id="professional_type" name="professional_type"
          value={formData.professional_type || ''} onChange={handleChange} required
          data-testid="intro-relationship-select"
          className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-hidden focus:ring-2 focus:ring-green-500"
        >
          <option value="" disabled>Select your relationship to this introducee</option>
          {availableTypes.map((t) => (<option key={t} value={t}>{t}</option>))}
        </select>
        <p className="text-xs text-gray-500 mt-1">
          You can introduce different clients under different roles — choose the one that best fits this introduction.
        </p>
      </div>
      <div>
        <label htmlFor="note" className="block text-sm font-medium text-gray-300 mb-2">Rationale for this introduction (Optional)</label>
        <textarea id="note" name="note" value={formData.note} onChange={handleChange} rows={3}
          className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-hidden focus:ring-2 focus:ring-green-500"
          placeholder="Briefly describe why you're introducing this client — for our review team only." />
        <p className="text-xs text-gray-500 mt-1">This note is reviewed by our team and is never shared with the client.</p>
      </div>
      <div className="bg-gray-700/50 rounded-lg p-4 space-y-2">
        <p className="text-sm text-gray-300 font-medium">Guidelines:</p>
        <ul className="text-sm text-gray-400 space-y-1 ml-4">
          {GUIDELINES.map(g => <li key={g}>- {g}</li>)}
        </ul>
      </div>
      <button type="submit" disabled={sending || (advisorInfo?.limit_info?.remaining === 0)}
        className="w-full py-3 bg-green-500 hover:bg-green-600 text-white rounded-lg font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed">
        {getSubmitButtonText()}
      </button>
      {advisorInfo?.limit_info?.remaining === 0 && (
        <p className="text-center text-sm text-yellow-400">You've reached your weekly limit. Limit resets on Monday.</p>
      )}
    </form>
  </div>
);

export default AdvisorClientForm;
